// Fly's opening text can change many times while its sections stay the same.
// Keep the validated cells on their grid host, rather than deriving them for
// every text frame. The vocabulary is deliberately read on EVERY call: a
// module's visibility function may depend on any reactive workspace field.
// Caching that authority by object identity would retain revoked sections.
export const assistantFlyStableCells = function assistantFlyStableCells(page, root, cols) {
  const host = this
  if (!page) {
    if (host) host.__flyRenderCache = null
    return []
  }
  const r = root || {}
  // The lists a section's LINK reads (a site card's ↗: the canvas and preview
  // link functions name a website out of `_projectsForActiveOrg` and an App
  // Store app out of `_wsAppsCatalog`) — read on EVERY call, so the grid
  // follows them, and compared by identity: a list that lands after the cells
  // were derived derives them again (MISSING-NAMES-2).
  const lists = [r._projectsForActiveOrg, r._wsAppsCatalog]
  const items = Array.isArray(page.items) ? page.items : []
  const vocabulary = items.some(Boolean) ? this.call('boardVocabularyFor', r) : null
  const lang = this.call('getActiveLang') || r.lang || ''
  const functions = []
  let signature
  try {
    signature = JSON.stringify(
      [
        (r.workspace && (r.workspace.id || r.workspace._id)) || null,
        lang,
        page.key,
        page.id,
        page.prompt,
        page.title,
        page.status,
        page.phase,
        !!page.onLayer,
        cols,
        items,
        // A UI section's line follows its read (functions/assistantFly.js
        // assistantFlyCells `readState`).
        Array.isArray(page.reads) ? page.reads : null,
        vocabulary
      ],
      (key, value) => {
        // JSON alone drops handlers in widget bodies/specs. Record identity as
        // well, so a module replacement cannot retain the previous callbacks.
        if (typeof value !== 'function') return value
        functions.push(value)
        return { flyFunction: functions.length }
      }
    )
  } catch (_) {
    // A malformed manifest must not make caching a prerequisite for a page.
    if (host) host.__flyRenderCache = null
    return this.call('assistantFlyCells', page, r, cols)
  }
  const previous = host && Object.hasOwn(host, '__flyRenderCache') && host.__flyRenderCache
  if (
    previous &&
    previous.signature === signature &&
    previous.functions.length === functions.length &&
    functions.every((fn, index) => fn === previous.functions[index]) &&
    Array.isArray(previous.lists) &&
    lists.every((list, index) => list === previous.lists[index])
  )
    return previous.cells
  const cells = this.call('assistantFlyCells', page, r, cols)
  if (host) host.__flyRenderCache = { signature, cells, functions, lists }
  return cells
}
